import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function SmsIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M10.5 18C10.5 18.8284 9.82843 19.5 9 19.5C8.17157 19.5 7.5 18.8284 7.5 18C7.5 17.1716 8.17157 16.5 9 16.5C9.82843 16.5 10.5 17.1716 10.5 18Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M5.5 1H4C2.3457 1 1 2.3457 1 4V20C1 21.6543 2.3457 23 4 23H14C15.6543 23 17 21.6543 17 20V12.5H15V20C15 20.5518 14.5513 21 14 21H4C3.44873 21 3 20.5518 3 20V4C3 3.44824 3.44873 3 4 3H5.5V1Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 4.2V15.5001L18.2001 10.9H10.2C8.43371 10.9 7 9.46629 7 7.7V4.2C7 2.43371 8.43371 1 10.2 1H19.8C21.5663 1 23 2.43371 23 4.2ZM10.2 8.9H18.8668L21 11.5V4.2C21 3.53828 20.4617 3 19.8 3H10.2C9.53828 3 9 3.53828 9 4.2V7.7C9 8.36172 9.53828 8.9 10.2 8.9Z",
    fill: "currentColor"
  }));
}